import { createContext } from 'react'

export const ChartContext = createContext({ width: 0, height: 0 })